export class GrouperDTOResponse {
  public id: number;
  public companyId: number;
  public name: string;
}
